// Icons are fixed in code and paired with the backend-managed perk text by
// index (order). Text lives in the NovaPerk model; only the icons stay here.
export const PERK_ICONS = [
  // Gift — welcome bonus
  `M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V19.5m0-14.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z`,
  // Calendar — recurring monthly points
  `M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5`,
  // Ticket — exclusive deals & vouchers
  `M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z`,
  // Trophy — extra draw entries
  `M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0`,
];

// Fallback text used if the backend is unreachable, so the section still
// renders its default content.
export const PERKS_FALLBACK = [
  {
    stat: "30.000",
    label: "πόντοι καλωσορίσματος",
    description: "Μόλις συνδέσεις τον λογαριασμό σου Nova με το PADU, σου χαρίζουμε αμέσως 30.000 πόντους.",
  },
  {
    stat: "3.000",
    label: "πόντοι κάθε μήνα",
    description: "Κάθε μήνα που είσαι συνδρομητής Nova κερδίζεις αυτόματα 3.000 επιπλέον πόντους.",
  },
  {
    stat: "Exclusive",
    label: "deals & vouchers",
    description: "Αποκλειστικές προσφορές και brand vouchers διαθέσιμα μόνο για συνδρομητές Nova.",
  },
  {
    stat: "Bonus",
    label: "συμμετοχές στις κληρώσεις",
    description: "Περισσότεροι πόντοι σημαίνουν περισσότερες συμμετοχές στις μηνιαίες κληρώσεις PADU.",
  },
];

export const STEPS = [
  {
    number: "01",
    title: "Κατέβασε το PADU",
    description: "Κατέβασε δωρεάν το app PADU από το App Store ή το Google Play.",
  },
  {
    number: "02",
    title: "Σύνδεσε τον λογαριασμό Nova",
    description: "Μέσα στο app, μεταβαίνεις στο προφίλ σου και συνδέεις τον λογαριασμό Nova με ένα κλικ.",
  },
  {
    number: "03",
    title: "Κέρδισε & εξαργύρωσε",
    description: "Σκανάρεις QR code σε κάθε αγορά σου, μαζεύεις πόντους και εξαργυρώνεις σε πάνω από 1.000 σημεία.",
  },
];

export const PARTNER_LOGOS = [
  { name: "Simply", color: "#e63946" },
  { name: "Pizza Fan", color: "#f4a261" },
  { name: "Wolt", color: "#009de0" },
  { name: "Box Now", color: "#2ec4b6" },
  { name: "HomeMarkt", color: "#e76f51" },
  { name: "AB Βασιλόπουλος", color: "#264653" },
  { name: "Kotsovolos", color: "#0057b8" },
  { name: "Media Markt", color: "#cc0000" },
];
